import { render, staticRenderFns } from "./SendForModerationModal.vue?vue&type=template&id=2b22f908&scoped=true&"
import script from "./SendForModerationModal.vue?vue&type=script&lang=ts&"
export * from "./SendForModerationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendForModerationModal.vue?vue&type=style&index=0&id=2b22f908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22f908",
  null
  
)

export default component.exports